module.exports = __webpack_public_path__ + "img/logoleft.ddc192eb.svg";